import { graphql } from '@/gql';
import { mutationExecute } from '@/Utils/graphqlAPI';

export const deleteOperatorFaq = async (id: string): Promise<boolean> => {
  const response = await mutationExecute({
    mutation: graphql(`
      mutation DeleteOperatorFaq($id: String!) {
        deleteOperatorFaq(id: $id)
      }
    `),
    variables: {
      id,
    },
  });

  return response.data?.deleteOperatorFaq ?? false;
};
